import React, { useEffect } from "react";
import CloseIcon from "../assets/CloseIcon.svg";

/**
 * The caller's own bet history, from `GET /api/roulette/my-bets`.
 * The source read a `wallet` document shape (`item.rouletteGame.*`) belonging
 * to a different platform; rows are now this game's own bet documents.
 */
export default function HistoryModel(props) {
  const { setOpen, open, historyData, frames } = props;

  const frameLabel = (frameId) => {
    const frame = (frames || []).find((f) => Number(f.id) === Number(frameId));
    return frame ? frame.label : `#${frameId}`;
  };

  function timeOf(dateString) {
    if (!dateString) return "";
    const dateObject = new Date(dateString);
    if (Number.isNaN(dateObject.getTime())) return "";
    return dateObject.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (open && !event.target.closest(".rules-model")) {
        setOpen(false);
      }
    };
    if (open) {
      document.addEventListener("click", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [open, setOpen]);

  if (!open) return null;

  return (
    <div className="rules-model">
      <div className="rulesModelBox">
        <div className="model-head">
          <h6>My History</h6>
          <button className="close-icon" onClick={() => setOpen(false)}>
            <CloseIcon />
          </button>
        </div>
        <div className="model-body">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Time</th>
                <th>Bet</th>
                <th>Amount</th>
                <th>Win</th>
              </tr>
            </thead>
            <tbody>
              {historyData && historyData.length > 0 ? (
                historyData.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{index + 1}</td>
                    <td>{timeOf(item.placedAt)}</td>
                    <td>
                      <div className="winner-Box">
                        <span className="winner-number">{frameLabel(item.frameId)}</span>
                      </div>
                    </td>
                    <td>{Number(item.amount || 0).toLocaleString()}</td>
                    <td style={{ color: item.won ? "#2ecc71" : "red", fontWeight: "500" }}>
                      {item.won ? `+${Number(item.payout || 0).toLocaleString()}` : "—"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <h6 className="not-history">No History...</h6>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
